import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'agreement-lpp-value',
  imports: [CommonModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="mb-3">
      <label class="form-label text-muted" style="font-size: 0.875rem; margin-bottom: 0.25rem;">
        <strong>{{ props.label }}</strong>
      </label>
      <p>{{ getLppValue.total | currency }} ( {{ getLppValue.totalFormat }} )</p>
    </div>
  `,
})
export class AgreementLppValueType extends FieldType<FieldTypeConfig> {
    get getLppValue(): any | null {
        const totalFormat = this.field.model.LPPTaxes.value !== ''
        ? 
        `${this.field.model.LPPPremium.value} + ${this.field.model.LPPTaxes.value}`
        :
        `${this.field.model.LPPPremium.value}`;

        return {
            total: this.field.model.LoanProtection.value, 
            totalFormat: totalFormat
        }
    }
}